import { render, staticRenderFns } from "./MonitoraggioPressioneEditComponent.vue?vue&type=template&id=aa7e8042"
import script from "./MonitoraggioPressioneEditComponent.vue?vue&type=script&lang=js"
export * from "./MonitoraggioPressioneEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports